import { render } from "./record.vue?vue&type=template&id=6e3c42a7"
import script from "./record.vue?vue&type=script&lang=js"
export * from "./record.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\pool_11_24\\pool_11_24\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__